import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import history from '../../../../history'

import Modal from '../../../../components/Modal'
import Button from '../../../../components/Button'
import { ReactComponent as CloseIcon } from '../../../../assets/icons/close-grey.svg'
import { ReactComponent as SuccessIcon } from '../../../../assets/icons/success-icon.svg'

import { createJsonFromQueryString } from '../../../../helpers/url'

import useStyles from './styles'

function SuccessModal({
  children,
  successButtonText,
  successButtonAction,
  modalType,
  showCloseButton = false,
  ...modalProps
}) {
  const { t } = useTranslation()
  const classes = useStyles()

  const [isSuccessModalOpened, setIsSuccessModalOpened] = useState(false)

  const { search } = useLocation()
  const { message: queryParamsModalType } = createJsonFromQueryString(search)

  const handleCloseSuccessModal = useCallback(() => {
    // Close modal and clear query params
    history.replace({
      search: ''
    })
    setIsSuccessModalOpened(false)
  }, [])

  const successButtonHandler = useCallback(() => {
    handleCloseSuccessModal()
    successButtonAction()
  }, [successButtonAction, handleCloseSuccessModal])

  useEffect(() => {
    if (queryParamsModalType === modalType && !isSuccessModalOpened) {
      setIsSuccessModalOpened(true)
    }
  }, [queryParamsModalType, isSuccessModalOpened, modalType])

  return (
    <Modal isOpen={isSuccessModalOpened} shouldFocusAfterRender={true} {...modalProps}>
      <CloseIcon className={classes.closeIcon} onClick={handleCloseSuccessModal} />
      <SuccessIcon />
      <h3 className={classes.title}>{t('Success!')}</h3>
      {children && <div className={classes.successText}>{children}</div>}
      {(showCloseButton || successButtonText) && (
        <div className={classes.btnContainer}>
          {showCloseButton && <Button onClick={handleCloseSuccessModal}>Close</Button>}
          {successButtonText && <Button onClick={successButtonHandler}>{t(successButtonText)}</Button>}
        </div>
      )}
    </Modal>
  )
}

SuccessModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  successButtonText: PropTypes.string,
  successButtonAction: PropTypes.func,
  modalType: PropTypes.string,
  showCloseButton: PropTypes.bool
}

export default SuccessModal
